module.exports = __webpack_public_path__ + "static/media/icon-new.43f811c6.ttf";